module.exports = __webpack_public_path__ + "img/highmast_comm_fault_on.6d9f2d8c.svg";